import { GAME_PARAMS } from '@beat-games/game-config';
import { useGameStore } from '../../stores/gameStore';

export default function GameHUD() {
  const { phase, elapsed, survivalTimeMs, isInsideCircle } = useGameStore();

  // Use survivalTimeMs when game ended (for consistency with game over screen), otherwise use live elapsed
  const displayedElapsed = survivalTimeMs !== null ? survivalTimeMs : elapsed;
  const timeRemaining = Math.max(0, GAME_PARAMS.maxDuration - displayedElapsed);
  const progressPercent = (displayedElapsed / GAME_PARAMS.maxDuration) * 100;

  const formatTime = (ms: number) => {
    const seconds = Math.floor(ms / 1000);
    const milliseconds = ms % 1000;
    return `${seconds}.${milliseconds.toString().padStart(3, '0')}`;
  };

  if (phase === 'waiting' || phase === 'countdown') {
    return null;
  }

  return (
    <>
      {/* Top HUD - Outside the canvas for cleaner look */}
      <div className="absolute -top-20 sm:-top-[4.5rem] left-0 right-0 flex justify-between items-end pointer-events-none px-1">
        {/* Time remaining */}
        <div className="animate-slide-up-fade">
          <div className="text-white/30 text-[10px] sm:text-xs uppercase tracking-[0.2em] mb-1">
            Remaining
          </div>
          <div className={`font-mono text-2xl sm:text-3xl font-bold tabular-nums ${
            timeRemaining < 10000 ? 'text-[#ef4444]' : 'text-white'
          }`}>
            {formatTime(timeRemaining)}s
          </div>
        </div>

        {/* Time Survived */}
        <div className="text-right animate-slide-up-fade" style={{ animationDelay: '0.05s' }}>
          <div className="text-white/30 text-[10px] sm:text-xs uppercase tracking-[0.2em] mb-1">
            Survived
          </div>
          <div className="font-mono text-2xl sm:text-3xl font-bold tabular-nums text-white">
            {formatTime(displayedElapsed)}s
          </div>
        </div>
      </div>

      {/* Progress bar - Outside canvas at bottom */}
      <div className="absolute -bottom-12 sm:-bottom-10 left-0 right-0 pointer-events-none animate-slide-up-fade px-1" style={{ animationDelay: '0.1s' }}>
        {/* Progress track */}
        <div className="h-1 bg-white/10 rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-100 rounded-full ${
              progressPercent > 80
                ? 'bg-gradient-to-r from-[#ef4444] to-[#f97316]'
                : progressPercent > 50
                ? 'bg-gradient-to-r from-[#f59e0b] to-[#eab308]'
                : 'bg-white'
            }`}
            style={{ width: `${progressPercent}%` }}
          />
        </div>

        {/* Progress milestones */}
        <div className="flex justify-between mt-2 text-[10px] text-white/20 font-mono">
          <span>0s</span>
          <span>15s</span>
          <span>30s</span>
          <span>45s</span>
        </div>
      </div>

      {/* Status indicator - inside canvas */}
      {!isInsideCircle && phase === 'playing' && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none z-20">
          <div className="px-4 sm:px-6 py-2 sm:py-3 bg-[#ef4444]/20 border border-[#ef4444]/50 rounded animate-pulse backdrop-blur-sm">
            <span className="text-[#ef4444] font-bold text-xs sm:text-sm uppercase tracking-[0.15em]">
              Get Back Inside!
            </span>
          </div>
        </div>
      )}
    </>
  );
}
